import { useState } from 'react';
import { useSelector } from 'react-redux';
import { generateReleaseNotes } from '../api';
import { RootState } from '../reducers/reducers';
import { selectAuthCredentials } from '../selectors/selectors';
import {
    GeneratedReleaseNotesMarkdownContext,
    GeneratedReleaseNotesStepContext,
    GeneratedReleaseNotesType,
} from '@/types';

export type GetGeneratedReleaseNotesHookResult = [
    getGeneratedReleaseNotes: (
        notesType: GeneratedReleaseNotesType,
        stepContext: GeneratedReleaseNotesStepContext,
        markdownContext: GeneratedReleaseNotesMarkdownContext,
        locale: string,
    ) => Promise<string>,
    isLoading: boolean,
    error: string,
];

export function useGetGeneratedReleaseNotes(
    orgId: string,
    appId: string,
    releaseId: string,
): GetGeneratedReleaseNotesHookResult {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const authCredentials = useSelector((state: RootState) => selectAuthCredentials(state));
    const getGeneratedReleaseNotesFunction = async (
        notesType: GeneratedReleaseNotesType,
        stepContext: GeneratedReleaseNotesStepContext,
        markdownContext: GeneratedReleaseNotesMarkdownContext,
        locale: string,
    ) => {
        setIsLoading(true);
        try {
            const result = await generateReleaseNotes(
                { orgId, appId, releaseId },
                authCredentials,
                notesType,
                stepContext,
                markdownContext,
                locale,
            );

            return result?.content;
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }

        return null;
    };
    return [getGeneratedReleaseNotesFunction, isLoading, error];
}
